import { render, staticRenderFns } from "./Monitoreo.vue?vue&type=template&id=1947ffe6&scoped=true"
import script from "./Monitoreo.vue?vue&type=script&lang=ts"
export * from "./Monitoreo.vue?vue&type=script&lang=ts"
import style0 from "./Monitoreo.vue?vue&type=style&index=0&id=1947ffe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947ffe6",
  null
  
)

export default component.exports